import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react'
import PropTypes from 'prop-types'

const MarkdownRteFlushContext = createContext(null)

export const MarkdownRteFlushProvider = ({ children, flushApiRef }) => {
  const flushersRef = useRef(new Set())

  const registerFlusher = useCallback(flush => {
    flushersRef.current.add(flush)
    return () => {
      flushersRef.current.delete(flush)
    }
  }, [])

  const flushAll = useCallback(() => {
    flushersRef.current.forEach(flush => flush())
  }, [])

  const value = useMemo(() => ({ registerFlusher, flushAll }), [
    registerFlusher,
    flushAll,
  ])

  useEffect(() => {
    if (!flushApiRef) return undefined
    flushApiRef.current = { flushAll }
    return () => {
      flushApiRef.current = null
    }
  }, [flushAll, flushApiRef])

  return (
    <MarkdownRteFlushContext.Provider value={value}>
      {children}
    </MarkdownRteFlushContext.Provider>
  )
}

MarkdownRteFlushProvider.propTypes = {
  children: PropTypes.node.isRequired,
  flushApiRef: PropTypes.shape({ current: PropTypes.any }),
}

export const useMarkdownRteFlushRegistration = () => {
  const context = useContext(MarkdownRteFlushContext)
  return context?.registerFlusher
}
